'use strict';var _desc,_value,_class;function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const Guid=require('pulsar-utils/dist-es6/domain/guid');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const{HandleUncaughtErrors}=require('../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations;
const BaseController=require('../../../../dist-es6/client/angularCommon/baseController');
const KeyboardKeys=require('../../../../dist-es6/client/common/keyboardKeys');

const _bindingDefaults={
inputId:Guid.create().toString(),
query:'',
label:'Search',
results:[],
selectedResult:null,
nextFormField:null,
showSelectedResult:!1,
fetchResultsFunction:()=>[]};


const _bindingDefaultKeys=_.keys(_bindingDefaults);let

TypeAheadController=(_class=class TypeAheadController extends BaseController{
constructor($scope,$element,$timeout,uncaughtErrorHandler){
super(uncaughtErrorHandler,$timeout,$scope);
this._$scope=$scope;
this._$timeout=$timeout;
this._$element=$element;
this._previousSelections=[];

_.defaults(this,_bindingDefaults);

this.query='';

this.showSelectedResult=!1;

this._safeWatch('selectedResult',res=>{
this._previousSelections=_.uniqWith(this._previousSelections.concat(res),_.isEqual);
this._moveToNextFormField();
});

this._$timeout(()=>{
this.__autocompleteElement=angular.element(this._$element).find('md-autocomplete input');

if(!_.exists(this.__autocompleteElement)){
this.showSelectedResult=!1;
return;
}

this.__autocompleteElement.
on('focus',()=>this._$timeout(()=>this.showSelectedResult=!1)).
on('blur',()=>this._$timeout(()=>this.showSelectedResult=!0));
});
}

_moveToNextFormField(){
if(this.nextFormField){
this._$timeout(()=>{
angular.element(this.nextFormField).focus();
});
}
}

hasVisited(result){
return this._previousSelections.some(s=>_.isEqual(s,result));
}


async _safelyFetchResults(query){
try{
this.results=await this.fetchResultsFunction(query);
}catch(err){
console.error(err);
return[];
}
return this.results;
}

focusInputField(fromDom){
const inputElement=this.__autocompleteElement;
if(!_.exists(inputElement)){
return;
}

this._$timeout(()=>{
angular.element(inputElement).focus();
this.showSelectedResult=!1;
});
}

get selectedResultIndex(){
return this.results.indexOf(this.selectedResult);
}},(_applyDecoratedDescriptor(_class.prototype,'_safelyFetchResults',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_safelyFetchResults'),_class.prototype)),_class);let


TypeAheadDirective=class TypeAheadDirective extends BaseControllerBackedDirective{
get templateUrl(){return'/templates/directives/typeAheadDirective/typeAheadTemplate'}

get objectBindings(){return _bindingDefaultKeys}

get $inject(){return['$scope','$element','$timeout','uncaughtErrorHandler']}

get controller(){return TypeAheadController}};


module.exports=TypeAheadDirective;
//# sourceMappingURL=typeAheadDirective.js.map
